var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { changeGalleryId, changeGalleryContents, loadGalleries, loadHasWixAccount, changeFlowState, loadPreview, hideDiscardModal, showDiscardModal, setInitialFormState, activatePortfolio, loadEmail, } from './actions';
import { handleActions } from 'redux-actions';
import { FlowState } from './types';
import { initialSocialNetworksLinksValue } from '../formSteps/state';
var actionHandlers = handleActions((_a = {},
    _a[changeGalleryId.toString()] = function (state, action) { return (__assign(__assign({}, state), { galleryId: action.payload.galleryId })); },
    _a[loadGalleries.toString()] = function (state, action) { return (__assign(__assign({}, state), { galleries: action.payload.galleries, galleryId: !state.galleryId && action.payload.galleries.length > 0
            ? action.payload.galleries[0].folderId
            : state.galleryId })); },
    _a[changeGalleryContents.toString()] = function (state, action) { return (__assign(__assign({}, state), { galleryContents: action.payload.galleryContents })); },
    _a[loadEmail.toString()] = function (state, action) { return (__assign(__assign({}, state), { email: action.payload.email })); },
    _a[loadHasWixAccount.toString()] = function (state, action) { return (__assign(__assign({}, state), { hasWixAccount: action.payload.hasWixAccount })); },
    _a[changeFlowState.toString()] = function (state, action) { return (__assign(__assign({}, state), { flowState: action.payload.flowState })); },
    _a[loadPreview.toString()] = function (state, action) { return (__assign(__assign({}, state), { previewUrl: action.payload.previewUrl, siteId: action.payload.siteId })); },
    _a[hideDiscardModal.toString()] = function (state, action) { return (__assign(__assign({}, state), { shouldDisplayDiscardModal: false })); },
    _a[showDiscardModal.toString()] = function (state, action) { return (__assign(__assign({}, state), { shouldDisplayDiscardModal: true })); },
    _a[setInitialFormState.toString()] = function (state, action) { return (__assign(__assign({}, state), { initialFormState: __assign(__assign(__assign({}, state.initialFormState), action.payload), { socialNetworkLinks: __assign(__assign({}, state.initialFormState.socialNetworkLinks), action.payload.socialNetworkLinks) }) })); },
    _a[activatePortfolio.toString()] = function (state, action) { return (__assign(__assign({}, state), { flowState: FlowState.ACTIVATING })); },
    _a), {
    galleryId: undefined,
    galleryContents: {
        deviations: [],
        total: 0,
    },
    galleries: [],
    hasWixAccount: false,
    flowState: FlowState.PRELOAD,
    previewUrl: undefined,
    shouldDisplayDiscardModal: false,
    email: undefined,
    initialFormState: {
        title: '',
        biography: '',
        description: '',
        themeId: '8c1b8a60f05a4b138cf275471b33a889',
        socialNetworkLinks: initialSocialNetworksLinksValue,
    },
    siteId: undefined,
});
var reducers = (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map